import { __extends } from "tslib";
import * as React from 'react';
import { SyntaxHighlighter, initializeSyntaxHighlights, getSyntaxHighlightStyle } from '../../syntax-highlighter';
var CodeComponent = /** @class */ (function (_super) {
    __extends(CodeComponent, _super);
    function CodeComponent(props) {
        var _this = _super.call(this, props) || this;
        initializeSyntaxHighlights();
        return _this;
    }
    CodeComponent.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { className: 'component code-component', "data-component-type": 'code' },
            React.createElement("div", { className: 'code-container', "data-language": props.value.language },
                React.createElement(SyntaxHighlighter, { codeTagProps: { className: 'code' }, language: props.value.language, wrapLines: props.value.lineWrapping, style: getSyntaxHighlightStyle(), showLineNumbers: true }, props.value.code))));
    };
    return CodeComponent;
}(React.PureComponent));
export { CodeComponent };
//# sourceMappingURL=code-component.comp.js.map